import React, { useEffect, useState } from "react";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import { Divider, Typography } from "antd";
import AiAssessmentAnswer from "./AiAssessmentAnswer";
import AiAssessmentQuestionText from "./AiAssessmentQuestionText";
import AiAssessmentQuestionActions from "./AiAssessmentQuestionActions";
import useAiAssessmentQuestionNavigation from "../../hooks/useAiAssessmentQuestionNavigation";
import "./aiAssessmentQuestions.scss";

const AiAssessmentQuestions: React.FC = () => {
  const [isCodingFullscreen, setIsCodingFullscreen] = useState(false);

  const { aiAssessmentQuestions, currentStep, isRoundFinished, isFullscreen } =
    useAIAssessmentContext();

  const { clearTemporaryAnswer } = useAiAssessmentQuestionNavigation();

  const currentQuestion = aiAssessmentQuestions[currentStep];

  const handleCodingFullscreenToggle = () => {
    setIsCodingFullscreen((prev) => !prev);
  };

  useEffect(() => {
    if (isCodingFullscreen && !isFullscreen) {
      setIsCodingFullscreen(false);
    } else {
      console.log("isCodingFullscreen is false");
    }
  }, [isCodingFullscreen, isFullscreen]);

  // Effect to clear the temporary answer when the question changes
  useEffect(() => {
    if (currentQuestion) {
      clearTemporaryAnswer();
    }
  }, [currentQuestion]);

  if (!currentQuestion) return null;

  const getAnswerSectionTitle = () => {
    switch (currentQuestion.answerType.toLowerCase()) {
      case "mcq":
        return "Options";
      case "descriptive":
        return "Answer";
      case "coding":
        return isRoundFinished || currentQuestion.answer !== null
          ? "Coding Answer"
          : "Code Editor";
      default:
        return "Answer";
    }
  };

  return (
    <div
      className={`ai-assessment-questions-container ${
        isCodingFullscreen ? "ai-assessment-questions-container-fullscreen" : ""
      }`}
    >
      <div className="ai-assessment-question-section">
        <div className="ai-assessment-section-title">
          <Typography.Title
            level={5}
            style={{ margin: "0px", fontSize: "14px" }}
          >
            Question {currentStep + 1}
          </Typography.Title>
        </div>
        <Divider style={{ margin: "0px" }} />
        <div className="ai-assessment-question-section-content">
          <AiAssessmentQuestionText />
          <AiAssessmentQuestionActions />
        </div>
      </div>
      <div className="ai-assessment-answer-section">
        <div className="ai-assessment-section-title">
          <Typography.Title
            level={5}
            style={{ margin: "0px", fontSize: "14px" }}
          >
            {getAnswerSectionTitle()}
          </Typography.Title>
        </div>
        <Divider style={{ margin: "0px" }} />
        <div className="ai-assessment-answer-section-content">
          <AiAssessmentAnswer
            handleCodingFullscreenToggle={handleCodingFullscreenToggle}
            isCodingFullscreen={isCodingFullscreen}
          />
        </div>
      </div>
    </div>
  );
};

export default AiAssessmentQuestions;
